/* eslint-disable react-hooks/rules-of-hooks */
import en from 'date-fns/locale/en-US';
import vi from 'date-fns/locale/vi';
import moment from 'moment';
import React, {
  memo,
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import 'react-multi-carousel/lib/styles.css';
import { DEFAULT_LANGUAGE, EXCHANGE_TICKETS_SELECTED } from 'utils/constants';

import { LoadingOutlined } from '@ant-design/icons';
import { Col, Divider, Form, Row, Select, Skeleton, Spin } from 'antd';
import { ReactComponent as ArrowDownIcon } from 'app/assets/img/arrow_down.svg';
import { ReactComponent as LocationIcon } from 'app/assets/img/icon_location_sub.svg';
import { ReactComponent as TimeIcon } from 'app/assets/img/icon_time_sub.svg';
import DatePickerComponent from 'app/components/DatePickerComponent';
import { InputNumberContainer } from 'app/components/InputNumberContainer/Loadable';
import RenderIf from 'app/components/RenderIf';
import { StyledStack } from 'app/components/Stack';
import { StyledTag } from 'app/components/StyledTag';
import useTicketTimes from 'app/hooks/useGetUsedArea2';
import useWindowSize from 'app/hooks/useWindowSize';
import { CART_ERROR_TYPE } from 'app/pages/Cart/components/TicketItem';
import GrandstandDiagram from 'app/pages/Cart/components/TicketItem/partials/components/GrandstandDiagram';
import { generateTicketIdentify } from 'app/pages/Cart/utils';
import {
  PriceDisplayStatus,
  QUANTITY_PROMOTION,
  QUANTITY_TAG,
} from 'app/pages/Catalog/FormItemTicket';
import TooltipParagraph from 'app/pages/Catalog/tooltipParagraph';
import { PriceWrapper } from 'app/pages/EditOrder/components/ShowItem';
import {
  getPriceCartApiWithCancelRequest,
  getShowDetailApi,
} from 'app/services/showApi';
import * as _ from 'lodash';
import styled from 'styled-components';
import { formatNumber, formatTimeFrame } from 'utils/helper';
import { getDateValidNormal } from '../helper';
import useInitData from './useInitData';

registerLocale('vi', vi);
registerLocale('en', en);
setDefaultLocale(DEFAULT_LANGUAGE);

export const SelectTickets = memo((props: any) => {
  const selectZonePopupContainer = useRef<HTMLDivElement>(null);
  const selectRestaurantPopupContainer = useRef<HTMLDivElement>(null);
  const selectPerformancePopupContainer = useRef<HTMLDivElement>(null);
  const getPriceAbortController = useRef<AbortController | null>(null);

  const {
    dataItem,
    translations,
    seeDetailShow,
    paymentMethod,
    isLoading,
    ticketFormId,
    isComboTicket,
    isComboDiffTicket,
    handelSelectExchange,
    handleChangeAmount,
    selectedTicket,
    amountExchange,
    minUnitPriceSelect,
    recallGetPrice,
    setRecallGetPrice,
    dateSelectable,
    allocatedDebt,
    isLongTerm,
    isShowTag,
    blockItems = [] as Record<string, any>[],
    isApiOrder,
    ticketErrors = [],
    setTicketErrors,
  } = props;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [form] = Form.useForm();
  const [objectDate, setObjectDate] = useState<any>(null);
  const [newDataItem, setNewDataItem] = useState<any>(dataItem);
  const [arrayUsedArea, setArrayUsedArea] = useState<any>(null);
  const parkNameRef = useRef<HTMLDivElement>(null);
  const [isValidSubmit, setIsValidSubmit] = useState(true);
  const [disableMinus, setDisableMinus] = useState(false);
  const debounceTimeout = useRef<NodeJS.Timeout | null>(null);
  const [loadingPrice, setLoadingPrice] = useState(false);
  const ChangeTicketRef = useRef<HTMLDivElement>(null);
  const [changeTicketDOMRect, setChangeTicketDOMRect] =
    useState<DOMRect | null>(null);
  const [hasFetchedPrice, setHasFetchedPrice] = useState(false);
  const [disableCreateOrder, setDisableCreateOrder] = useState(false);

  const { device } = useWindowSize();

  const isTicketCable = useMemo(() => {
    return dataItem?.materialType === '9005';
  }, [dataItem?.materialType]);
  const restaurantSelected = form.getFieldValue(`${dataItem?.id}-restaurant`);
  const zoneSelected = form.getFieldValue(`${dataItem?.id}-zone`);
  const grandstandData = useMemo(() => {
    const restaurantByIdSelected = dataItem?.restaurants?.find(
      i => i?.id === restaurantSelected,
    );
    if (!_.isEmpty(dataItem?.restaurants)) {
      return restaurantByIdSelected ?? dataItem?.restaurants?.[0];
    }
    if (_.isEmpty(dataItem?.zones)) {
      return zoneSelected ?? dataItem?.zones?.[0];
    }
    return undefined;
  }, [
    dataItem?.restaurants,
    form,
    dataItem?.id,
    restaurantSelected,
    dataItem?.zones,
    zoneSelected,
  ]);

  const minAmount = useMemo(() => {
    setDisableMinus(true);
    const _minAmount = dataItem?.minAmountB2b || 1;
    if (_minAmount > amountExchange) {
      setIsValidSubmit(false);
    }
    return _minAmount;
  }, [dataItem?.minAmountB2b, amountExchange, form, translations]);

  const [loadingMinPrice, setLoadingMinPrice] = useState(false);
  const areAllExchangeTicketsHaveSamePrice = blockItems?.every(
    item => item?.originalPrice === blockItems?.[0]?.originalPrice,
  );
  const {
    usedArea2Data,
    priceData,
    loading: loadingInitData,
    fetched: fetchedInitData,
  } = useInitData({
    showId: dataItem.id,
    date: dateSelectable,
    zones: dataItem.zones?.map(i => i?.id),
    restaurants: dataItem.restaurants?.map(i => i?.id),
    bpAllocatedDebt: allocatedDebt,
    isCableTicket: isTicketCable,
    isLongTerm,
    paymentMethod,
    amount: amountExchange,
    checkMinUnitPrice: (price: number) => {
      const unitPriceCondition = areAllExchangeTicketsHaveSamePrice
        ? 'GREATER_THAN_OR_EQUAL'
        : 'GREATER_THAN';

      if (
        (unitPriceCondition === 'GREATER_THAN_OR_EQUAL' &&
          price < minUnitPriceSelect) ||
        (unitPriceCondition === 'GREATER_THAN' && price <= minUnitPriceSelect)
      )
        return false;
      return true;
    },
    minAmount,
    isApiOrder,
  });
  useEffect(() => {
    if (!_.isEmpty(ticketErrors)) {
      setIsValidSubmit(false);
      for (let index = 0; index < ticketErrors.length; index++) {
        const element = ticketErrors[index];
        form.setFields([
          {
            name: element?.field,
            errors: [element.error],
          },
        ]);
      }
    } else {
      setIsValidSubmit(true);
    }
  }, [ticketErrors]);
  useEffect(() => {
    if (!fetchedInitData) return;

    setObjectDate({ [`date-${dataItem.id}`]: dateSelectable });
    form.setFieldValue(
      `${dataItem?.id}-date`,
      moment(dateSelectable).format('YYYY-MM-DD'),
    );

    const ticketExchangeSelectedJSON = sessionStorage.getItem(
      EXCHANGE_TICKETS_SELECTED,
    );

    const ticketExchangeSelected = !!ticketExchangeSelectedJSON
      ? JSON.parse(ticketExchangeSelectedJSON)?.selectedTicket?.[0]
      : null;

    const ticketExchangeSelectedPriceData = (() => {
      if (!ticketExchangeSelected || !ticketExchangeSelected.identify)
        return null;

      return priceData?.find(i => {
        const identify = generateTicketIdentify({
          showId: i.show_id,
          usedArea2: i.used_area2,
          zoneId: i.zone_id,
          date: i.date,
          restaurantId: i.restaurant_id,
        });

        return identify === ticketExchangeSelected.identify;
      });
    })();

    const firstValidTicketShow = isTicketCable
      ? priceData?.[0]
      : ticketExchangeSelectedPriceData ??
        priceData.find(i => i._fe_check_valid);

    const isHaveNoZoneAndRestaurant =
      !dataItem?.zones?.length && !dataItem?.restaurants?.length;

    if (isHaveNoZoneAndRestaurant) {
      setArrayUsedArea({
        [`${dataItem.id}-used_area2`]:
          usedArea2Data?.[0]?.data?.map(item => ({
            label: formatTimeFrame(item.label),
            value: item.value,
          })) ?? [],
      });
    } else if (firstValidTicketShow) {
      setArrayUsedArea({
        [`${dataItem.id}-used_area2`]: usedArea2Data
          .find(
            i =>
              +i.zone_restaurant === +firstValidTicketShow.restaurant_id ||
              +i.zone_restaurant === +firstValidTicketShow.zone_id,
          )
          ?.data?.map(item => ({
            label: formatTimeFrame(item.label),
            value: item.value,
          })),
      });
    }

    if (!firstValidTicketShow) {
      setLoadingMinPrice(true);
      getShowDetailApi({
        id: dataItem.id,
        date: moment(dateSelectable).format('YYYY-MM-DD'),
        ticketType: sessionStorage.getItem('ticketType'),
      })
        .then(res => {
          setNewDataItem({
            ...dataItem,
            minPrice: res?.data?.minPrice,
          });
        })
        .catch((error: any) => {
          setIsValidSubmit(false);
          form.setFields([
            { name: `${dataItem.id}-date`, errors: [error?.message] },
          ]);
        })
        .finally(() => {
          setLoadingMinPrice(false);
        });

      return;
    }

    const inventory = +(firstValidTicketShow.inventory || 0);

    form.setFields([
      {
        name: `${dataItem.id}-restaurant`,
        value: +firstValidTicketShow?.restaurant_id,
      },
      { name: `${dataItem.id}-zone`, value: +firstValidTicketShow?.zone_id },
      {
        name: `${dataItem.id}-used_area2`,
        value: firstValidTicketShow?.used_area2,
      },
    ]);

    const numberAddDays =
      isComboTicket && isComboDiffTicket
        ? 0
        : firstValidTicketShow?.versionB2b || 0;

    let fromDate = moment(dateSelectable).format('HH:mm DD/MM/YYYY');
    let toDate = newDataItem.dateTo.datetimeDMY;

    let getDateRange = getDateValidNormal(
      fromDate,
      toDate,
      numberAddDays,
      'DD/MM/YYYY',
      isComboTicket,
      isComboDiffTicket,
    );

    // Set nhanh dữ liệu từ batch để form có option hiển thị ngay.
    // Giá này sẽ được single get-price bên dưới cập nhật lại cho đúng giá thực tế.
    setNewDataItem({
      ...dataItem,
      originalPrice: firstValidTicketShow.originalPrice,
      price: firstValidTicketShow.price,
      inventory,
      numberAddDays,
      dateSelectFrom: getDateRange.fromDate,
      dateSelectTo: getDateRange.toDate,
      childName: firstValidTicketShow.name,
      ticketId: firstValidTicketShow?.id,
    });

    if (!isTicketCable) {
      const formData = new FormData();
      formData.append('forceTicketType', !!isLongTerm ? '1' : '0');
      formData.append('notValidateAmount', '1');
      if (isApiOrder) formData.append('numberChannel', '50');
      formData.append('items[0][date]', moment(dateSelectable).format('YYYY-MM-DD'));
      formData.append('items[0][show_id]', dataItem.id.toString());
      formData.append('items[0][amount]', amountExchange.toString());
      formData.append('items[0][payment]', paymentMethod.toString());
      formData.append('items[0][used_area2]', firstValidTicketShow.used_area2);
      if (firstValidTicketShow.zone_id)
        formData.append('items[0][zone_id]', firstValidTicketShow.zone_id);
      if (firstValidTicketShow.restaurant_id)
        formData.append(
          'items[0][restaurant_id]',
          firstValidTicketShow.restaurant_id,
        );
      if (allocatedDebt !== null && allocatedDebt !== undefined)
        formData.append('items[0][bpAllocatedDebt]', allocatedDebt.toString());

      // Batch get-price phía trên có thể làm backend hiểu là nhiều vé ở nhiều khung giờ,
      // khiến chính sách khuyến mãi theo số lượng trả về giá không đúng cho 1 option.
      // Vì vậy gọi lại đúng option đã chọn để lấy giá chuẩn cho khung giờ thực tế.
      getPriceCartApiWithCancelRequest(formData).then(res => {
        const repricedTicketShow = res?.data?.[0];
        if (!repricedTicketShow) return;

        setNewDataItem(prev => ({
          ...prev,
          originalPrice:
            repricedTicketShow.originalPrice ?? prev.originalPrice,
          price: repricedTicketShow.price ?? prev.price,
          inventory: +(repricedTicketShow.inventory ?? prev.inventory ?? 0),
          childName: repricedTicketShow.name ?? prev.childName,
          ticketId: repricedTicketShow?.id ?? prev.ticketId,
        }));
      });
    }

    let fieldName = `${dataItem.id}-date`;
    const msg = firstValidTicketShow?.error?.message || '';

    if (
      [
        CART_ERROR_TYPE.JUMP_TICKET,
        CART_ERROR_TYPE.MIN_TICKET,
        CART_ERROR_TYPE.ERROR_TICKET,
      ].includes(firstValidTicketShow.error?.errorType)
    ) {
      fieldName = `${dataItem.id}-amount`;
    }

    if (msg) {
      form.setFields([
        {
          name: fieldName,
          errors: [msg],
        },
      ]);
      setIsValidSubmit(false);
    } else {
      setIsValidSubmit(
        inventory >= minAmount &&
          inventory >= amountExchange &&
          minAmount <= amountExchange,
      );
      if (inventory < amountExchange) {
        setIsValidSubmit(false);
      }
    }
  }, [
    allocatedDebt,
    amountExchange,
    dataItem,
    dateSelectable,
    form,
    isApiOrder,
    isComboDiffTicket,
    isComboTicket,
    isLongTerm,
    isTicketCable,
    minAmount,
    newDataItem.dateTo.datetimeDMY,
    paymentMethod,
    priceData,
    usedArea2Data,
    fetchedInitData,
  ]);

  const isHiddenGrand = useMemo(() => {
    return (
      _.isEmpty(dataItem?.restaurants) || dataItem?.materialType === '9005'
    );
  }, [dataItem?.restaurants]);

  const hasRestaurants = useMemo(() => {
    return !_.isNil(dataItem?.restaurants) && !_.isEmpty(dataItem?.restaurants);
  }, [dataItem?.restaurants]);

  const getTicketTimeOptions = useMemo(
    () => ({
      payloadData: {
        date: form.getFieldValue(`${dataItem?.id}-date`),
        show_id: dataItem?.id,
        restaurant_id: form.getFieldValue(`${dataItem?.id}-restaurants`),
        zone_id: form.getFieldValue(`${dataItem?.id}-zone`),
      },
      applyZone: !isTicketCable,
      applyUsedZone2: !isTicketCable,
      isRestaurant: hasRestaurants,
      IIFE: false,
    }),
    [],
  );

  const { onFetchData } = useTicketTimes(getTicketTimeOptions);

  const clearFormError = () => {
    form.setFields([
      {
        name: `${dataItem?.id}-date`,
        errors: [],
      },
      {
        name: `${dataItem?.id}-amount`,
        errors: [],
      },
    ]);
  };

  const getPrice = async (params: {
    date: string;
    zone_id?: string;
    show_id: string;
    used_area2?: string;
    restaurant_id?: string;
    amount: string;
  }) => {
    try {
      clearFormError();
      setIsValidSubmit(false);
      setLoadingPrice(true);
      const formData = new FormData();
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          formData.append(`items[0][${key}]`, value);
        }
      });
      formData.append('items[0][payment]', paymentMethod);
      formData.append('notValidateAmount', '1');
      if (isApiOrder) formData.append('numberChannel', '50');
      formData.append('forceTicketType', !!isLongTerm ? '1' : '0');

      if (allocatedDebt !== null && allocatedDebt !== undefined)
        formData.append('items[0][bpAllocatedDebt]', allocatedDebt);

      if (getPriceAbortController.current)
        getPriceAbortController.current.abort();

      getPriceAbortController.current = new AbortController();

      setHasFetchedPrice(true);

      const res = await getPriceCartApiWithCancelRequest(
        formData,
        getPriceAbortController.current.signal,
      );
      if (res?.status === 200 && _.isArray(res?.data) && res?.data.length > 0) {
        const dataInventory = res?.data[0];
        const _price: number = dataInventory.price;
        form.setFieldsValue({
          [`${params.show_id}-price`]: _price,
        });
        form.setFields([{ name: `${params.show_id}-date`, errors: [] }]);
        const inventory = +(dataInventory?.inventory || 0);
        // expired date

        const numberAddDays =
          isComboTicket && isComboDiffTicket
            ? 0
            : dataInventory?.versionB2b || 0;
        let fromDate = moment(params.date).format('HH:mm DD/MM/YYYY');
        let toDate = newDataItem.dateTo.datetimeDMY;

        let getDateRange = getDateValidNormal(
          fromDate,
          toDate,
          numberAddDays,
          'DD/MM/YYYY',
          isComboTicket,
          isComboDiffTicket,
        );
        setNewDataItem({
          ...dataItem,
          originalPrice: dataInventory.originalPrice,
          price: _price,
          inventory,
          numberAddDays,
          dateSelectFrom: getDateRange.fromDate,
          dateSelectTo: getDateRange.toDate,
          childName: dataInventory.name,
          ticketId: dataInventory?.id,
        });

        let fieldName = `${params.show_id}-date`;
        let msg = dataInventory?.error?.message || '';
        if (
          [
            CART_ERROR_TYPE.JUMP_TICKET,
            CART_ERROR_TYPE.MIN_TICKET,
            CART_ERROR_TYPE.ERROR_TICKET,
          ].includes(res?.data?.[0]?.error?.errorType)
        ) {
          fieldName = `${dataItem.id}-amount`;
        }

        if (msg) {
          form.setFields([
            {
              name: fieldName,
              errors: [msg],
            },
          ]);
          setIsValidSubmit(false);
        } else {
          setIsValidSubmit(
            inventory >= minAmount &&
              inventory >= amountExchange &&
              minAmount <= amountExchange,
          );
          if (inventory < amountExchange) {
            setIsValidSubmit(false);
          }
        }
      }
    } catch (error: any) {
      if (error?.code?.toLowerCase() === 'err_canceled') return;
      form.setFields([
        { name: `${params.show_id}-date`, errors: [error?.message] },
      ]);
      setIsValidSubmit(false);
    } finally {
      setRecallGetPrice && setRecallGetPrice(false);
      setLoadingPrice(false);
    }
  };

  const getMinPrice = async (params: { date: string; show_id: number }) => {
    try {
      clearFormError();
      setIsValidSubmit(false);
      setLoadingPrice(true);
      const res = await getShowDetailApi({
        id: params.show_id,
        date: params.date,
        ticketType: sessionStorage.getItem('ticketType'),
      });

      if (res?.status === 200) {
        setNewDataItem({
          ...dataItem,
          minPrice: res?.data?.minPrice,
        });
      }
    } catch (error: any) {
      form.setFields([
        { name: `${params.show_id}-date`, errors: [error?.message] },
      ]);
      setIsValidSubmit(false);
    } finally {
      setLoadingPrice(false);
    }
  };

  const callUsedArea = () => {
    onFetchData({
      payloadData: {
        date: form.getFieldValue(`${dataItem?.id}-date`),
        show_id: dataItem?.id,
        restaurant_id: form.getFieldValue(`${dataItem?.id}-restaurant`),
        zone_id: form.getFieldValue(`${dataItem?.id}-zone`),
        forceTicketType: !!isLongTerm ? '1' : '0',
        ...(allocatedDebt ? { bpAllocatedDebt: allocatedDebt } : {}),
      },
      callback: {
        onBefore: () => {
          return true;
        },
        onSuccess: resUsedArea => {
          // TODO
          setArrayUsedArea({
            [`${dataItem.id}-used_area2`]: resUsedArea.data.map(item => ({
              label: formatTimeFrame(item.label),
              value: item.value,
            })),
          });

          if (resUsedArea.data?.length === 1) {
            handleChangeUsedArea2(resUsedArea.data[0].value, dataItem.id);
          } else if (
            _.isEmpty(form.getFieldValue(`${dataItem?.id}-used_area2`))
          ) {
            getMinPrice({
              date: form.getFieldValue(`${dataItem?.id}-date`),
              show_id: dataItem?.id,
            });
          }
        },
        onError: error => {
          setArrayUsedArea({
            [`${dataItem.id}-used_area2`]: [],
          });
        },
        onFinally: () => {},
      },
    });
  };

  const handleChangeUsedArea2 = useCallback(
    (used_area2, id) => {
      const zoneForm = form.getFieldValue(`${dataItem.id}-zone`);
      const dateForm = form.getFieldValue(`${dataItem.id}-date`);
      const restaurantForm = form.getFieldValue(`${dataItem.id}-restaurant`);
      const amount = form.getFieldValue(`${id}-amount`);
      form.setFieldsValue({ [`${id}-used_area2`]: used_area2 });
      if (dateForm) {
        getPrice({
          date: moment(dateForm).format('YYYY-MM-DD'),
          zone_id: zoneForm ?? '',
          show_id: id,
          used_area2,
          restaurant_id: restaurantForm ?? '',
          amount: amount < minAmount ? minAmount : amount,
        });
      }
    },
    [form, getPrice, paymentMethod, dataItem.id],
  );

  const onChangeZone = (value: any, id: any) => {
    form.setFieldsValue({ [`${id}-used_area2`]: null });
    setArrayUsedArea({
      [`${id}-used_area2`]: [],
    });
    callUsedArea();
  };

  const onChangeRestaurant = (value: any, id: any) => {
    form.setFieldsValue({ [`${id}-used_area2`]: null });
    setArrayUsedArea({
      [`${id}-used_area2`]: [],
    });
    callUsedArea();
  };
  const convertDataOption = (arr, type) => {
    let result = [];
    if (arr?.length) {
      result = arr.map(item => ({
        ...item,
        value: item.id,
        label: ['zone', 'restaurants'].includes(type)
          ? item?.name
          : item?.timeFrom,
      }));
    }
    return result;
  };
  const onFinishForm = (values, dataItem, form) => {
    setIsValidSubmit(false);
    if (checkIsSelected && !_.isEmpty(ticketErrors)) {
      setTicketErrors([]);
    }
    if (values[`${dataItem.id}-date`]) {
      values.date = values[`${dataItem.id}-date`];
      delete values[`${dataItem.id}-date`];
    }
    if (values[`${dataItem.id}-zone`]) {
      values.zone = values[`${dataItem.id}-zone`];
      delete values[`${dataItem.id}-zone`];
    }
    if (values[`${dataItem.id}-restaurant`]) {
      values.restaurant = values[`${dataItem.id}-restaurant`];
      delete values[`${dataItem.id}-restaurant`];
    }
    if (values[`${dataItem.id}-used_area2`]) {
      values.used_area2 = values[`${dataItem.id}-used_area2`];
      delete values[`${dataItem.id}-used_area2`];
    }
    if (values[`${dataItem.id}-amount`]) {
      values.amount = values[`${dataItem.id}-amount`] ?? minAmount;
      delete values[`${dataItem.id}-amount`];
    }
    // create-order
    const dataTemp = {
      ...newDataItem,
      show_id: newDataItem.id,
      amount: values?.amount ?? 1,
      date: moment(values.date).format('YYYY-MM-DD'),
      used_area2: values?.used_area2,
      zone_object: _.isNumber(values?.zone)
        ? newDataItem?.zones.find((item: any) => {
            return +item.id === +values?.zone;
          })
        : null,
      zone_id: values?.zone,
      payment: paymentMethod,
      deliver_ticket_id: ticketFormId,
      price: newDataItem.price,
      restaurant_object: _.isNumber(values?.restaurant)
        ? newDataItem?.restaurants.find((item: any) => {
            return +item.id === +values?.restaurant;
          })
        : null,
      restaurant_id: values?.restaurant,
    };
    handelSelectExchange(dataTemp);
    setIsValidSubmit(true);
  };
  const dateForm = form.getFieldValue(`${dataItem.id}-date`);
  const usedArea2Form = form.getFieldValue(`${dataItem.id}-used_area2`);
  const zoneForm = form.getFieldValue(`${dataItem.id}-zone`);
  const restaurantForm = form.getFieldValue(`${dataItem.id}-restaurant`);

  const checkIsSelected = useMemo(() => {
    let _isSelected = false;
    if (!_.isEmpty(selectedTicket) && !_.isEmpty(dataItem)) {
      const identify = generateTicketIdentify({
        showId: dataItem.id,
        usedArea2: usedArea2Form,
        zoneId: zoneForm,
        date: dateForm,
        restaurantId: restaurantForm,
      });

      const findTicketInuse = selectedTicket?.find(
        i => i?.identify === identify,
      );

      if (!_.isEmpty(findTicketInuse)) {
        form.setFields([
          {
            name: `${newDataItem.id}-amount`,
            value: findTicketInuse?.amount,
            errors: [],
          },
        ]);
      }
      _isSelected = !_.isEmpty(findTicketInuse);
    }
    return _isSelected;
  }, [
    selectedTicket,
    dataItem.id,
    usedArea2Form,
    zoneForm,
    restaurantForm,
    dateForm,
  ]);

  const checkDisabled = useMemo(() => {
    let _isDisabled = false;

    const errorDate = form.getFieldError(`${dataItem.id}-date`);

    if (!isValidSubmit) {
      _isDisabled = true;
    }
    if (!checkIsSelected && !_.isEmpty(selectedTicket)) {
      _isDisabled = true;
    }
    if (loadingPrice) {
      _isDisabled = true;
    }
    if (minAmount > amountExchange && _.isEmpty(errorDate) && !loadingPrice) {
      _isDisabled = true;
      form.setFields([
        {
          name: `${dataItem.id}-amount`,
          value: amountExchange,
          errors: [
            translations?.['b2c.catalog-detail.min-amount'].replace(
              '${number}',
              minAmount,
            ),
          ],
        },
      ]);
    }

    if (
      props?.minUnitPriceSelect &&
      +newDataItem?.price >= 0 &&
      _.isEmpty(errorDate) &&
      !loadingPrice
    ) {
      const areAllExchangeTicketsHaveSamePrice = blockItems?.every(
        item => item?.originalPrice === blockItems?.[0]?.originalPrice,
      );

      const unitPriceCondition = areAllExchangeTicketsHaveSamePrice
        ? 'GREATER_THAN_OR_EQUAL'
        : 'GREATER_THAN';

      if (
        unitPriceCondition === 'GREATER_THAN_OR_EQUAL' &&
        +newDataItem?.price < +props?.minUnitPriceSelect
      ) {
        _isDisabled = true;
        if (_.isEmpty(errorDate)) {
          form.setFields([
            {
              name: `${dataItem.id}-amount`,
              errors: [translations?.['b2b.txt.error-unit-ticket-exchange']],
            },
          ]);
        }
      } else if (
        unitPriceCondition === 'GREATER_THAN' &&
        +newDataItem?.price <= +props?.minUnitPriceSelect
      ) {
        _isDisabled = true;
        if (_.isEmpty(errorDate)) {
          form.setFields([
            {
              name: `${dataItem.id}-amount`,
              errors: [translations?.['b2b.txt.newPriceMustBeGreater']],
            },
          ]);
        }
      }
    }
    if (
      +newDataItem?.inventory >= 0 &&
      newDataItem?.inventory < amountExchange &&
      _.isEmpty(errorDate) &&
      !loadingPrice
    ) {
      _isDisabled = true;
      form.setFields([
        {
          name: `${dataItem.id}-amount`,
          errors: [translations?.['b2b.txt.error-inventory-exchange']],
        },
      ]);
    }
    if (checkIsSelected) {
      _isDisabled = false;
    }

    return _isDisabled;
  }, [
    checkIsSelected,
    selectedTicket,
    isValidSubmit,
    props?.minUnitPriceSelect,
    newDataItem?.price,
    dataItem?.id,
    translations,
    form,
    loadingPrice,
    newDataItem?.inventory,
    amountExchange,
    minAmount,
    blockItems,
  ]);

  const resetTimeout = amount => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {
      const _value = amount;
      const used_area2 = form.getFieldValue(`${newDataItem.id}-used_area2`);
      const zone = form.getFieldValue(`${newDataItem.id}-zone`);
      const date = form.getFieldValue(`${newDataItem.id}-date`);
      const restaurant = form.getFieldValue(`${newDataItem.id}-restaurant`);
      const identify = generateTicketIdentify({
        showId: newDataItem.id,
        usedArea2: used_area2,
        zoneId: zone,
        date: date,
        restaurantId: restaurant,
      });
      const findTicketInuse = selectedTicket?.find(
        i => i?.identify === identify,
      );

      form.setFields([
        {
          name: `${dataItem.id}-amount`,
          value: _value,
          errors: [],
        },
      ]);

      if (!_.isEmpty(findTicketInuse)) {
        handleChangeAmount(identify, _value);
      }
      getPrice({
        date: date,
        zone_id: zone,
        show_id: dataItem.id,
        used_area2,
        restaurant_id: restaurant,
        amount: _value,
      });
    }, 500);
  };

  const _handleChangeAmount = (value, id) => {
    const isError = value < minAmount;
    setDisableMinus(value <= minAmount);
    form.setFields([
      {
        name: `${dataItem.id}-amount`,
        value: +value <= 0 ? minAmount : value,
        errors: isError
          ? [
              translations?.['b2c.catalog-detail.min-amount'].replace(
                '${number}',
                minAmount,
              ),
            ]
          : [],
      },
    ]);
    setIsValidSubmit(!isError && newDataItem?.inventory >= minAmount);
    !isError && newDataItem?.inventory >= minAmount && resetTimeout(value);
  };

  useMemo(() => {
    if (_.isInteger(paymentMethod)) {
      setIsValidSubmit(true);
      let checkIsCallGetPrice = false;
      if (dataItem?.materialType === '9005') {
        checkIsCallGetPrice = !_.isEmpty(
          form.getFieldValue(`${dataItem.id}-date`),
        );
      } else {
        checkIsCallGetPrice =
          !_.isEmpty(form.getFieldValue(`${dataItem.id}-date`)) &&
          !_.isEmpty(form.getFieldValue(`${dataItem.id}-used_area2`));
      }

      if (checkIsCallGetPrice) {
        clearFormError();
        const amount = form.getFieldValue(`${dataItem.id}-amount`);
        getPrice({
          date: form.getFieldValue(`${dataItem.id}-date`),
          zone_id: form.getFieldValue(`${dataItem.id}-zone`),
          show_id: dataItem.id,
          used_area2: form.getFieldValue(`${dataItem.id}-used_area2`),
          restaurant_id: form.getFieldValue(`${dataItem.id}-restaurant`),
          amount: amount < minAmount ? minAmount : amount,
        });
      }
    }
  }, [
    paymentMethod,
    dataItem.id,
    dataItem?.materialType,
    minAmount,
    recallGetPrice,
  ]);

  const parkName = dataItem?.park?.name;
  const itemNote = dataItem?.note;

  const usedArea1Label =
    dataItem?.usedArea1Label || translations?.['b2c.text.restaurants'] || '';

  const displayOriginalPriceFormat = useMemo(() => {
    const originalPrice = newDataItem?.originalPrice;
    const price = newDataItem?.price;
    const minPrice = newDataItem?.minPrice;

    let displayStatus: string = PriceDisplayStatus.NA;

    const handleChangeStaus = (
      disableCreateOrderValue: boolean,
      displayStatusValue: string,
    ) => {
      setDisableCreateOrder(disableCreateOrderValue);
      displayStatus = displayStatusValue;
    };

    (() => {
      if (_.isNil(originalPrice) && hasFetchedPrice) {
        // Không có ngày chọn hoặc không có giá cơ bản sau khi fetch → NA
        handleChangeStaus(true, PriceDisplayStatus.NA);
        return;
      }

      if (_.isNil(price)) {
        // Không có giá bán
        if (!_.isNil(minPrice)) {
          // Có minB → Hiển thị "Giá chỉ từ"
          handleChangeStaus(true, PriceDisplayStatus.SHOW_FROM_PRICE);
        } else {
          // Không có minB → NA
          handleChangeStaus(true, PriceDisplayStatus.NA);
        }
        return;
      }

      if (price === 0) {
        // Có CB và B = 0 → Hiển thị CB + B (bình thường) nhưng không mua được
        handleChangeStaus(true, PriceDisplayStatus.SHOW_BASE_PRICE);
        return;
      }

      if (originalPrice > price) {
        // CB > B → Hiển thị CB + B → mua được
        handleChangeStaus(false, PriceDisplayStatus.SHOW_BASE_PRICE);
        return;
      }

      if (originalPrice === 0 || originalPrice <= price) {
        // CB == B hoặc CB < B hoặc CB = 0 → chỉ hiển thị B → mua được
        handleChangeStaus(false, PriceDisplayStatus.SHOW_PRICE_ONLY);
        return;
      }

      // Trường hợp còn lại → NA
      handleChangeStaus(true, PriceDisplayStatus.NA);
    })();

    switch (displayStatus) {
      case PriceDisplayStatus.NA:
        return (
          <div className="--price" style={{ position: 'relative', top: 6 }}>
            <span className="--price-na">N/Ađ</span>
          </div>
        );

      case PriceDisplayStatus.SHOW_BASE_PRICE:
        return (
          <>
            <del className="--price-old">
              {formatNumber(originalPrice || 0)}đ
            </del>
            <div className="--price" style={{ position: 'static', top: 6 }}>
              {formatNumber(price || 0)}đ
            </div>
          </>
        );

      case PriceDisplayStatus.SHOW_PRICE_ONLY:
        return (
          <div className="--price" style={{ position: 'static', top: 6 }}>
            {formatNumber(price || 0)}đ
          </div>
        );

      case PriceDisplayStatus.SHOW_FROM_PRICE:
        return (
          <>
            <span className="--price-from-text">
              {translations
                ? translations['b2c.txt.price_only_from']
                : 'Giá chỉ từ'}
            </span>
            <div className="--price" style={{ position: 'static', top: 6 }}>
              {formatNumber(minPrice || 0)}đ
            </div>
          </>
        );

      default:
        return (
          <div className="--price" style={{ position: 'relative', top: 6 }}>
            <span className="--price-na">N/Ađ</span>
          </div>
        );
    }
  }, [newDataItem, translations]);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useLayoutEffect(() => {
    const onSetGroupTicketDetailDOMRect = () => {
      if (!ChangeTicketRef.current) return;
      setChangeTicketDOMRect(ChangeTicketRef.current.getBoundingClientRect());
    };

    onSetGroupTicketDetailDOMRect();

    window.addEventListener('resize', onSetGroupTicketDetailDOMRect);

    return () => {
      window.removeEventListener('resize', onSetGroupTicketDetailDOMRect);
    };
  }, []);
  const DEFAULT_IMAGE = '/static/img/Banner.png';
  return (
    <>
      <Col className="itemTicket">
        <div
          className="--group-img col-md-12 col-12 img-fluid"
          style={{
            border: dataItem?.image?.original ? 'none' : '1px solid #d9d9d9',
          }}
        >
          <img
            src={dataItem?.image?.original || DEFAULT_IMAGE}
            alt=""
            loading="lazy"
            onError={e => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = DEFAULT_IMAGE;
            }}
          />

          {dataItem?.salePercentB2b ? (
            <div className="--discount-img">{`-${dataItem?.salePercentB2b}%`}</div>
          ) : undefined}
          <div className="--learn-more" onClick={() => seeDetailShow(dataItem)}>
            <div style={{ marginRight: 6 }}>
              {' '}
              {translations ? translations['b2c.txt.read-more'] : ''}
            </div>
            <i className="fa-solid fa-chevron-right"></i>
          </div>
        </div>
        <div className="group-detail-ticket" ref={ChangeTicketRef}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginTop: device !== 'desktop' ? '16px' : '0px',
            }}
          >
            <TooltipParagraph
              className="--title"
              style={{
                margin: 0,
              }}
            >
              {dataItem.name}
            </TooltipParagraph>

            {isShowTag && (
              <div
                style={{
                  padding: '4px 8px',
                  whiteSpace: 'nowrap',
                  background: '#F54949',
                  borderRadius: '8px',
                  color: 'white',
                  height: '25px',
                  fontSize: '12px',
                  marginLeft: '10px',
                }}
              >
                {
                  translations?.[
                    `${
                      dataItem?.isLongTerm
                        ? 'b2b.txt.long-term'
                        : 'b2b.txt.short-term'
                    }`
                  ]
                }
              </div>
            )}
          </div>
          <div className="d-flex" style={{ marginTop: -2, marginBottom: 4 }}>
            {parkName ? (
              <div
                className="d-flex align-items-center"
                style={{
                  maxWidth: itemNote ? 180 : '100%',
                  width: '100%',
                }}
                ref={parkNameRef}
              >
                <LocationIcon style={{ flexShrink: 0 }} />
                <TooltipParagraph
                  className="--description-name-park"
                  style={{ maxWidth: 'calc(100% - 18px)', width: '100%' }}
                >
                  {dataItem?.park?.name}
                </TooltipParagraph>
              </div>
            ) : null}
            {dataItem?.note ? (
              <div
                className="d-flex align-items-center"
                style={{
                  maxWidth: parkName
                    ? `calc(100% - ${
                        parkNameRef.current?.getBoundingClientRect().width! + 10
                      }px)`
                    : '100%',
                  width: '100%',
                }}
              >
                <TimeIcon style={{ flexShrink: 0 }} />
                <TooltipParagraph
                  className="--description-note"
                  max={1}
                  style={{ maxWidth: 'calc(100% - 16px)', width: '100%' }}
                >
                  {dataItem?.note}
                </TooltipParagraph>
              </div>
            ) : null}
          </div>
          <div
            style={{
              marginTop: dataItem?.tagInfoResponse?.length ? '16px' : 0,
              marginBottom: 16,
            }}
          >
            {dataItem?.tagInfoResponse?.length ? (
              <StyledStack
                direction={'row'}
                style={{ flexWrap: 'wrap' }}
                rowGap={'6px'}
                columnGap={'6px'}
              >
                {dataItem?.tagInfoResponse
                  ?.slice(0, QUANTITY_TAG)
                  .map((itemTag, index) => (
                    <StyledTag
                      key={index}
                      title={
                        <div
                          style={{
                            gap: '5px',
                            color: itemTag?.textColor,
                          }}
                        >
                          {itemTag.content}
                        </div>
                      }
                      {...itemTag}
                      icon={itemTag?.icon?.original}
                    />
                  ))}
                {dataItem?.tagInfoResponse?.length > QUANTITY_TAG && (
                  <StyledTag
                    title={dataItem?.tagInfoResponse
                      ?.slice(QUANTITY_TAG)
                      .map(item => (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'start',
                            alignItems: 'center',
                            gap: '8px',
                            color: item?.textColor,
                            marginBottom: '5px',
                          }}
                        >
                          <img
                            src={item?.icon?.original}
                            alt=""
                            height={'auto'}
                            width={14}
                          />
                          {item.content}
                        </div>
                      ))}
                    content={
                      <div style={{ fontWeight: 500 }}>
                        +{dataItem?.tagInfoResponse.length - QUANTITY_TAG}
                      </div>
                    }
                    textColor="#EC000B"
                    bgColor="#FFD6D6"
                  />
                )}
              </StyledStack>
            ) : null}
          </div>
          <div
            style={{
              marginTop: dataItem?.promotionInfoResponse?.length ? '16px' : 0,
              marginBottom: 16,
            }}
          >
            {dataItem?.promotionInfoResponse?.length ? (
              <StyledStack
                direction={'row'}
                style={{ flexWrap: 'wrap' }}
                rowGap={'6px'}
                columnGap={'6px'}
              >
                {dataItem?.promotionInfoResponse
                  ?.slice(0, QUANTITY_PROMOTION)
                  .map((itemPromotion, index) => (
                    <StyledTag
                      key={index}
                      title={
                        <div
                          style={{
                            gap: '5px',
                            color: itemPromotion?.textColor,
                          }}
                        >
                          {itemPromotion.content}
                        </div>
                      }
                      {...itemPromotion}
                      icon={itemPromotion?.icon?.original}
                    />
                  ))}
                {dataItem?.promotionInfoResponse?.length >
                  QUANTITY_PROMOTION && (
                  <StyledTag
                    title={dataItem?.promotionInfoResponse
                      ?.slice(QUANTITY_PROMOTION)
                      .map(item => (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'start',
                            alignItems: 'center',
                            gap: '8px',
                            color: item?.textColor,
                            marginBottom: '5px',
                          }}
                        >
                          <img
                            src={item?.icon?.original}
                            alt=""
                            height={'auto'}
                            width={14}
                          />
                          {item.content}
                        </div>
                      ))}
                    content={
                      <div style={{ fontWeight: 500 }}>
                        +
                        {dataItem?.promotionInfoResponse.length -
                          QUANTITY_PROMOTION}
                      </div>
                    }
                    textColor="#EC000B"
                    bgColor="#FFD6D6"
                  />
                )}
              </StyledStack>
            ) : null}
          </div>
          <Form
            form={form}
            key={dataItem.id}
            onFinish={values => onFinishForm(values, dataItem, form)}
            // form={formInstances[index]}
          >
            <Row gutter={[32, 16]}>
              <Col span={device === 'desktop' ? 12 : 24} id="use-date-ticket">
                <Form.Item
                  className="custom-input"
                  label=""
                  name={`${dataItem.id}-date`}
                  rules={[
                    {
                      required: true,
                      message: translations
                        ? translations['b2c.txt.validateDate']
                        : '',
                    },
                  ]}
                  initialValue={
                    objectDate?.[`date-${dataItem.id}`]
                      ? moment(objectDate?.[`date-${dataItem.id}`])
                      : null
                  }
                  style={{ marginBottom: 0 }}
                >
                  <div className="d-flex align-items-center">
                    <div className="calender d-flex align-items-center col-md-6 col-12">
                      <DatePickerComponent
                        disabled
                        format="DD/MM/YYYY"
                        value={dateSelectable}
                        style={{
                          backgroundColor: 'transparent',
                        }}
                        inputStyle={{ color: '#000000d9 !important' }}
                      />
                    </div>
                  </div>
                </Form.Item>
              </Col>
              <Col
                span={device === 'desktop' ? 6 : 12}
                className="box-item"
                id="price-ticket"
              >
                {loadingPrice || loadingInitData || loadingMinPrice ? (
                  <Skeleton.Button
                    active
                    shape={'square'}
                    block
                    style={{ width: 100, opacity: 0.2 }}
                  />
                ) : (
                  <PriceWrapper>{displayOriginalPriceFormat}</PriceWrapper>
                )}
              </Col>
              <Col
                span={device === 'desktop' ? 6 : 12}
                className="box-item"
                id="amount-ticket"
              >
                <Form.Item
                  className="custom-input ticket-count"
                  label=""
                  name={`${dataItem.id}-amount`}
                  initialValue={
                    amountExchange >= minAmount ? amountExchange : minAmount
                  }
                  style={{
                    marginBottom: 0,
                    display: 'flex',
                    flexDirection: 'row-reverse',
                  }}
                >
                  <div className="form-inputNumber">
                    <InputNumberContainer
                      value={amountExchange}
                      onChange={value =>
                        _handleChangeAmount(value, dataItem.id)
                      }
                      min={minAmount}
                      max={amountExchange}
                      isLoading={isLoading}
                      isDisableMinus={true}
                      disabled
                    />
                  </div>
                </Form.Item>
              </Col>
              <RenderIf
                condition={
                  (dataItem?.materialType !== '9005' &&
                    !_.isEmpty(dataItem?.zones)) ||
                  (dataItem?.materialType !== '9005' &&
                    !_.isEmpty(dataItem?.restaurants)) ||
                  !isTicketCable
                }
                fallback={device === 'desktop' ? <Col span={12} /> : <></>}
              >
                <Col
                  span={device === 'desktop' ? 12 : 24}
                  className="box-feature-ticket"
                  id="ticket-zone"
                >
                  <Row style={{ width: 'calc(100% + 16px)' }} gutter={16}>
                    {dataItem?.materialType !== '9005' &&
                      !_.isEmpty(dataItem?.zones) && (
                        <Col span={12} className="--item-form box-item">
                          <SelectPopupContainer
                            ref={selectZonePopupContainer}
                            popupMaxWidth={
                              !!changeTicketDOMRect?.width
                                ? `${changeTicketDOMRect?.width}px`
                                : undefined
                            }
                            popupWidth={
                              device === 'desktop'
                                ? 'initial'
                                : !!changeTicketDOMRect?.width
                                ? `${changeTicketDOMRect?.width}px`
                                : undefined
                            }
                          />
                          <Form.Item
                            className="custom-input"
                            label=""
                            name={`${dataItem.id}-zone`}
                            rules={[
                              {
                                required: true,
                                message: translations
                                  ? translations['b2c.txt.validateZone']
                                  : '',
                              },
                            ]}
                            style={{ marginBottom: 0 }}
                          >
                            <StyledSelect
                              getPopupContainer={() =>
                                selectZonePopupContainer.current!
                              }
                              options={convertDataOption(
                                dataItem?.zones,
                                'zone',
                              )}
                              dropdownRender={menu => (
                                <div className="custom-dropdown">{menu}</div>
                              )}
                              virtual={false}
                              placeholder={usedArea1Label}
                              onChange={value => {
                                if (value) onChangeZone(value, dataItem.id);
                              }}
                              suffixIcon={
                                loadingInitData ? (
                                  <Spin
                                    indicator={
                                      <LoadingOutlined
                                        style={{ fontSize: 12 }}
                                        spin
                                      />
                                    }
                                  />
                                ) : (
                                  <ArrowDownIcon />
                                )
                              }
                              disabled={
                                loadingPrice ||
                                loadingMinPrice ||
                                loadingInitData
                              }
                            />
                          </Form.Item>
                        </Col>
                      )}
                    {dataItem?.materialType !== '9005' &&
                      !_.isEmpty(dataItem?.restaurants) && (
                        <Col
                          span={12}
                          className="--item-form box-item"
                          id="ticket-zone"
                        >
                          <SelectPopupContainer
                            ref={selectRestaurantPopupContainer}
                            popupMaxWidth={
                              !!changeTicketDOMRect?.width
                                ? `${
                                    changeTicketDOMRect?.width -
                                    (device === 'desktop' &&
                                    !isTicketCable &&
                                    !_.isEmpty(dataItem?.zones)
                                      ? 140
                                      : 0)
                                  }px`
                                : undefined
                            }
                            popupWidth={
                              device === 'desktop'
                                ? 'initial'
                                : !!changeTicketDOMRect?.width
                                ? `${changeTicketDOMRect?.width}px`
                                : undefined
                            }
                          />
                          <Form.Item
                            className="custom-input"
                            label=""
                            name={`${dataItem.id}-restaurant`}
                            rules={[
                              {
                                required: true,
                                message: translations
                                  ? translations['b2c.txt.validateRestaurants']
                                  : '',
                              },
                            ]}
                            style={{ marginBottom: 0 }}
                          >
                            <StyledSelect
                              getPopupContainer={() =>
                                selectRestaurantPopupContainer.current!
                              }
                              options={convertDataOption(
                                dataItem?.restaurants,
                                'restaurants',
                              )}
                              dropdownRender={menu => (
                                <div className="custom-dropdown">{menu}</div>
                              )}
                              virtual={false}
                              placeholder={usedArea1Label}
                              onChange={value => {
                                if (value)
                                  onChangeRestaurant(value, dataItem.id);
                              }}
                              suffixIcon={
                                loadingInitData ? (
                                  <Spin
                                    indicator={
                                      <LoadingOutlined
                                        style={{ fontSize: 12 }}
                                        spin
                                      />
                                    }
                                  />
                                ) : (
                                  <ArrowDownIcon />
                                )
                              }
                              disabled={
                                loadingPrice ||
                                loadingMinPrice ||
                                loadingInitData
                              }
                              placement={
                                device !== 'desktop' &&
                                !isTicketCable &&
                                !_.isEmpty(dataItem?.zones)
                                  ? 'bottomRight'
                                  : 'bottomLeft'
                              }
                            />
                          </Form.Item>
                        </Col>
                      )}
                    {!isTicketCable && (
                      <Col
                        className="--item-form"
                        id="ticket-performance"
                        span={12}
                      >
                        <>
                          <SelectPopupContainer
                            ref={selectPerformancePopupContainer}
                            popupMaxWidth={
                              !!changeTicketDOMRect?.width
                                ? `${changeTicketDOMRect?.width}px`
                                : undefined
                            }
                            popupWidth={
                              device === 'desktop'
                                ? 'initial'
                                : !!changeTicketDOMRect?.width
                                ? `${changeTicketDOMRect?.width}px`
                                : undefined
                            }
                          />
                          <Form.Item
                            className="custom-input"
                            label=""
                            name={`${dataItem.id}-used_area2`}
                            rules={[
                              {
                                required: true,
                                message: translations
                                  ? translations['b2c.txt.plsChoose']
                                  : '',
                              },
                            ]}
                            style={{ marginBottom: 0 }}
                          >
                            <StyledSelect
                              getPopupContainer={() =>
                                selectPerformancePopupContainer.current!
                              }
                              options={
                                arrayUsedArea?.[`${dataItem.id}-used_area2`]
                              }
                              dropdownRender={menu => (
                                <div className="custom-dropdown">{menu}</div>
                              )}
                              virtual={false}
                              value={form.getFieldValue(
                                `${dataItem.id}-used_area2`,
                              )}
                              onChange={value =>
                                handleChangeUsedArea2(value, dataItem.id)
                              }
                              placeholder={
                                _.isEmpty(dataItem?.usedArea2Label)
                                  ? translations
                                    ? translations['b2c.txt.hours']
                                    : ''
                                  : dataItem?.usedArea2Label
                              }
                              suffixIcon={
                                loadingInitData ? (
                                  <Spin
                                    indicator={
                                      <LoadingOutlined
                                        style={{ fontSize: 12 }}
                                        spin
                                      />
                                    }
                                  />
                                ) : (
                                  <ArrowDownIcon />
                                )
                              }
                              disabled={
                                loadingPrice ||
                                loadingMinPrice ||
                                loadingInitData ||
                                (isComboTicket && isComboDiffTicket
                                  ? (arrayUsedArea?.[
                                      `${dataItem.id}-used_area2`
                                    ]?.length ?? 0) === 0
                                  : !objectDate?.[`date-${dataItem.id}`])
                              }
                              placement={
                                device !== 'desktop' &&
                                +_.isEmpty(dataItem?.restaurants) +
                                  +_.isEmpty(dataItem?.zones) ===
                                  1
                                  ? 'bottomRight'
                                  : 'bottomLeft'
                              }
                              loading
                            />
                          </Form.Item>
                        </>
                      </Col>
                    )}
                  </Row>
                </Col>
              </RenderIf>
              <Col
                span={device === 'desktop' ? 12 : 24}
                className="box-btn order-xs-last d-flex"
                id="ticket-submit"
              >
                {/* btn submit */}
                <div
                  className="--item-form col-md-3 col-12 col-sm-12 "
                  id="ticket-submit"
                >
                  <button
                    type="submit"
                    className={`--btn-buy-now ${
                      checkIsSelected ? 'un-select' : ''
                    }`}
                    onClick={() => {
                      form.setFieldsValue({ type: 'buy' });
                    }}
                    style={{
                      marginLeft: 0,
                    }}
                    disabled={checkDisabled || disableCreateOrder}
                  >
                    {translations
                      ? checkIsSelected
                        ? translations['b2b.btn.unchecked']
                        : translations['b2c.txt.select-tickets']
                      : ''}
                  </button>
                </div>
              </Col>
              <RenderIf
                condition={!isHiddenGrand || _.isNumber(newDataItem?.inventory)}
              >
                <>
                  <Col className="--item-form" id="ticket-grandstand" span={12}>
                    {!isHiddenGrand ? (
                      <div style={{ width: 130 }}>
                        <GrandstandDiagram
                          grandstandData={grandstandData}
                          textCSS={{ marginTop: '0px' }}
                        />
                      </div>
                    ) : null}
                  </Col>
                  <Col
                    className="--item-form txt-ticket-count"
                    id="ticket-inventory"
                    span={12}
                  >
                    {_.isNumber(newDataItem?.inventory) && (
                      <span
                        className="txt-ticket-count"
                        style={{
                          color: '#808080',
                          fontWeight: 400,
                          textAlign: 'right',
                        }}
                      >
                        {'('}
                        {formatNumber(newDataItem?.inventory || 0)}{' '}
                        {translations
                          ? `${translations['b2c.txt.in-stock']}`
                          : ''}
                        {')'}
                      </span>
                    )}
                  </Col>
                </>
              </RenderIf>
            </Row>
          </Form>
        </div>
      </Col>
      <Divider
        style={{
          border: 'none',
          borderBottom: 'dashed 2px #d9d9d9',
          margin: '24px 0 34px',
        }}
      />
    </>
  );
});
const StyledSelect = styled(Select)`
  width: 133px;
  .ant-select-selection-placeholder {
    color: #808080;
  }
  &.ant-select-disabled {
    .ant-select-selector {
      background-color: #ffffff !important;
    }
  }
  &.ant-select {
    .ant-select-selector {
      border: none;
      border-bottom: solid 1px #ededed;
      height: 40px;
      align-items: center;
      padding-left: 2px;
    }
    .ant-select-disabled {
      background: #ffffff;
    }
    &:hover {
      .ant-select-selector {
        border-color: #ededed;
      }
    }
  }
`;

const SelectPopupContainer = styled.div<{
  popupMaxWidth?: string;
  popupWidth?: string;
}>`
  & > div:first-child {
    z-index: 1;
  }

  .ant-select-dropdown {
    width: ${props => props.popupWidth ?? 'initial'}!important;
    max-width: ${props => props.popupMaxWidth ?? 'initial'};
  }
`;
